<div class="noselect total-price ws-product-detail__total">
  @if (!disabled) {
    <span [translate]="'common.total'">Total</span>&nbsp;<strong class="ws-product-detail__total-value">{{getPrice() | currencyFormat}}</strong>&nbsp;{{currency}}
  } @else {
    <span [translate]="'common.total'">Total</span>&nbsp;<strong class="ws-product-detail__total-value">0</strong>&nbsp;{{currency}}
  }
</div>
